import {
  getAuditLogResponseSchema,
  type GetAuditLogResponse,
} from "@mg/schemas/src/christo/catalyst";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

export interface GetAuditLogParams {
  pageSize?: number;
  page?: number;
  // Date range filter for cycle_start
  startDate?: string; // ISO date string
  endDate?: string; // ISO date string
  // Array of atomic task IDs to filter by (e.g., ["AT1", "AT3", "AT5"] or ["1", "3", "5"])
  atomicTasks?: string[];
}

export async function getAuditLog(
  params: GetAuditLogParams = {},
): Promise<GetAuditLogResponse> {
  const searchParams = new URLSearchParams();

  if (params.pageSize !== undefined) {
    searchParams.set("pageSize", params.pageSize.toString());
  }
  if (params.page !== undefined) {
    searchParams.set("page", params.page.toString());
  }
  if (params.startDate) {
    searchParams.set("startDate", params.startDate);
  }
  if (params.endDate) {
    searchParams.set("endDate", params.endDate);
  }
  // Add each atomic task as a separate query param (Express will parse as array)
  if (params.atomicTasks && params.atomicTasks.length > 0) {
    params.atomicTasks.forEach((task) => {
      searchParams.append("atomicTasks", task);
    });
  }

  const queryString = searchParams.toString();
  const url = `${API_URL}/private/catalyst/audit-log${queryString ? `?${queryString}` : ""}`;

  const json = await smartFetch(url, {
    method: "GET",
  });

  try {
    return getAuditLogResponseSchema.parse(json);
  } catch (error) {
    console.error("Failed to parse audit log response:", error);
    return json as GetAuditLogResponse;
  }
}
